module.exports = __webpack_public_path__ + "img/43.30f0215c.jpg";